import { render } from "./ConsultorioList.vue?vue&type=template&id=1363934f&scoped=true"
import script from "./ConsultorioList.vue?vue&type=script&lang=js"
export * from "./ConsultorioList.vue?vue&type=script&lang=js"

import "./ConsultorioList.vue?vue&type=style&index=0&id=1363934f&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1363934f"]])

export default __exports__